import styled from 'styled-components';
import {alignCss} from '../../styles/align.styled';
import {textCss} from '../../styles/text.styled';
import {backgroundCss} from '../../styles/background.styled';
import {boxCss} from '../../styles/box.styled';


export const GroupContainer = styled.div`
  width: 100%;
  margin: 0 auto!important;
  padding: 24px 12px;
  ${backgroundCss};
  ${textCss};
  ${boxCss};

  .dlf-page-content-group {
    > div {
      ${alignCss};
    }
  }

`;

GroupContainer.defaultProps = {};

